module.exports = __webpack_public_path__ + "static/media/juras.c2b512eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/juras.jpg
// module id = 496
// module chunks = 0